/**
 * iter-338v (BOQEditPage Refactor Phase A):
 * Lock & Snapshot dialog — extracted verbatim from BOQEditPage.jsx.
 * State stays owned by the parent (backwards-compat with the current handler),
 * this component is purely presentational so no behaviour changes.
 */
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { Pin } from 'lucide-react';

export default function SnapshotDialog({
  open,
  onOpenChange,
  label,
  onLabelChange,
  notes,
  onNotesChange,
  busy,
  snapshotsCount = 0,
  project,
  worksheet,
  onConfirm,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="snapshot-dialog">
        <DialogHeader>
          <DialogTitle className="font-manrope text-2xl text-stone-900 flex items-center gap-2">
            <Pin className="text-violet-600" />
            Lock &amp; Snapshot BOQ
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="bg-violet-50 border border-violet-200 p-3 rounded-md text-xs text-violet-800">
            Captures the current BOQ state as a permanent <span className="font-semibold">PDF + Excel</span> pair, stored in GridFS. The snapshot is admin-deletable with a logged reason; the live BOQ remains editable.
          </div>
          {project?.name && (
            <div className="text-xs text-stone-600">
              <span className="font-semibold">Project:</span> {project.name}
              {worksheet?.worksheet_number && (
                <> · <span className="font-semibold">BOQ:</span> {worksheet.worksheet_number}</>
              )}
            </div>
          )}
          <div>
            <Label className="text-stone-900">Version Label *</Label>
            <Input
              value={label}
              onChange={(e) => onLabelChange(e.target.value)}
              placeholder={`Snapshot ${snapshotsCount + 1}`}
              className="bg-white text-stone-900"
              data-testid="snapshot-label-input"
            />
            <p className="text-[11px] text-stone-500 mt-1">e.g. &quot;Pre-RA1 Submission&quot;, &quot;Client Sign-off v2&quot;, &quot;Phase-1 Frozen&quot;</p>
          </div>
          <div>
            <Label className="text-stone-900">Notes <span className="text-stone-400 text-xs">(Optional)</span></Label>
            <Textarea
              rows={3}
              value={notes}
              onChange={(e) => onNotesChange(e.target.value)}
              placeholder="What changed? Why is this version important?"
              className="bg-white text-stone-900"
              data-testid="snapshot-notes-input"
            />
          </div>
          <div className="flex justify-end gap-2 pt-2">
            <Button variant="outline" onClick={() => onOpenChange(false)} disabled={busy} data-testid="snapshot-cancel-btn">
              Cancel
            </Button>
            <Button
              onClick={onConfirm}
              disabled={busy || !label.trim()}
              className="bg-violet-600 hover:bg-violet-700 text-white"
              data-testid="snapshot-confirm-btn"
            >
              <Pin size={14} className="mr-1" />{busy ? 'Locking…' : 'Lock & Snapshot'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
